import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-activity-amount-range-restriction',
  templateUrl: './activity-amount-range-restriction.component.html',
  styleUrls: ['./activity-amount-range-restriction.component.scss'],
})
export class ActivityAmountRangeRestrictionComponent implements OnInit {
  @Input() amountRange: any;
  conditions: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  ngOnInit(): void {
    this.conditions = [
      { value: true, text: 'IS' },
      { value: false, text: 'IS NOT' },
    ];
  }

  initRestrictionObject(): void {
    console.log(this.amountRange);
    var tmpObj = {
      class:
        'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Restrictions$Behavioral$AmountRange',
    };
    if (this.amountRange) {
      this.amountRange.push(tmpObj);
    } else {
      this.amountRange = [];
      this.amountRange.push(tmpObj);
    }
    console.log(this.amountRange);
  }

  updateRestrictions() {
    this.debouncer.next(this.amountRange);
  }

  removeRestriction(restriction) {
    this.amountRange.splice(this.amountRange.indexOf(restriction), 1);
    this.updateRestrictions();
  }
}
